import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@root/globalTypes';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { DashboardsColumnsRespSuccess } from './types';
import { usePanelUrl } from './helpers';
import { useParams } from 'react-router';
import { useQueryParams } from '@hooks/queryParams';
import { DashboardsColumnDialogValue, DashboardsSourceType } from '@contexts/dashboards/types';

export const useGetDashboardsColumns = (
  scope: DashboardsSourceType[],
  { edit, values: { dashboardTableName, dashboardAttribute } }: DashboardsColumnDialogValue,
) => {
  const { tenantId } = useParams();
  const { parseParams } = useQueryParams();

  const queryParams = parseParams(
    {
      scope,
      dashboardTableName: edit ? dashboardTableName : undefined,
      dashboardAttribute: edit ? dashboardAttribute : undefined,
    },
    { arrayFormat: 'bracket' },
  );

  const opt = usePanelUrl(`dashboards/columns${queryParams}`);

  const { data, error, isPending, refetch } = useQuery<DashboardsColumnsRespSuccess, ApiError>({
    queryKey: [...queryKeys.dashboards.columns, tenantId, queryParams],
    queryFn: () => queryFetch(opt),
    placeholderData: (previousData) => previousData as DashboardsColumnsRespSuccess,
  });

  return {
    data,
    error,
    isLoading: isPending,
    refetch,
  };
};
